import { Button } from "@mui/material";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import {
  deleteInvoice,
  getClientInvoices,
  getCustomerInvoices,
  sendInvoiceWhatsappApi,
} from "../../utils/api";
import CustomModal from "../Modal";
import Table from "../Table";
import DeleteModal from "./DeleteModal";

const InvoicesModal = ({ id, client, hideDelete, onUpdate }) => {
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [sendingId, setSendingId] = useState(null);
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const getInvoicesHandler = async () => {
    setLoading(true);
    const [success, data] = client
      ? await getClientInvoices(id)
      : await getCustomerInvoices(id);
    if (success) {
      setData(data);
    }
    setLoading(false);
  };
  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          setOpen(true);
          getInvoicesHandler();
        }}
      >
        Invoices
      </Button>
      <CustomModal
        width={"md:w-[56rem]"}
        open={open}
        setOpen={setOpen}
        title="Invoices"
        button={<></>}
      >
        <Table
          columns={[
            {
              title: "INVOICE No.",
              dataIndex: "invoiceNumberString",
            },
            {
              title: "DATE",
              dataIndex: "invoiceDate",
              render: (date) =>
                new Date(date?.invoiceDate).toLocaleDateString("en-GB"),
            },
            {
              title: "CUSTOMER",
              dataIndex: "customer",
              render: (customer) => <>{customer?.customer?.userName}</>,
            },
            {
              title: "TOTAL",
              dataIndex: "grandTotal",
              render: (total) => <>{total?.grandTotal?.toFixed(2)}</>,
            },
            {
              title: "WhatsApp",
              render: (row) => (
                <div className="flex items-center gap-2">
                  <button
                    type="button"
                    disabled={sendingId === row._id}
                    onClick={async () => {
                      setSendingId(row._id);
                      const [success, res] = await sendInvoiceWhatsappApi(row._id, row?.customer?._id);
                      if (success) {
                        toast.success("✅ Invoice PDF sent to customer WhatsApp!");
                      } else {
                        toast.error(typeof res === "string" ? res : "Failed to send WhatsApp");
                      }
                      setSendingId(null);
                    }}
                    className="bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-800 text-white font-bold text-[11px] px-2.5 py-1 rounded shadow-sm transition active:scale-95 cursor-pointer disabled:opacity-50 inline-flex items-center gap-1"
                    title="Send WhatsApp Invoice PDF"
                  >
                    <span>💬</span>
                    <span>{sendingId === row._id ? "Sending..." : "Send"}</span>
                  </button>
                  <Link
                    to={`/admin/invoice/${row._id}`}
                    target="_blank"
                    className="text-indigo-600 hover:underline text-xs font-semibold"
                  >
                    View
                  </Link>
                </div>
              ),
            },
            {
              title: "Print",
              render: (row) => (
                <Link
                  to={`/admin/invoice/${row._id}?type=white`}
                  target="_blank"
                  className="text-black"
                >
                  View Invoice
                </Link>
              ),
            },

            !hideDelete
              ? {
                  title: "Actions",
                  render: (row) => (
                    <DeleteModal
                      loading={loading2}
                      onClick={async () => {
                        setLoading2(true);
                        const [success, data] = await deleteInvoice(row._id);
                        if (success) {
                          toast.success("Invoice Deleted Successfully");
                          getInvoicesHandler();
                          onUpdate?.();
                          window.dispatchEvent(new Event("plabel-data-updated"));
                          localStorage.setItem("plabel_last_sync", Date.now().toString());
                        }
                        setLoading2(false);
                      }}
                    />
                  ),
                }
              : null,
          ]}
          data={data}
        />
      </CustomModal>
    </div>
  );
};

export default InvoicesModal;
